import Image from 'next/image';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { EXPONENT_VENUE_LABELS, ExponentVenue, Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export const ExponentTriggerFullDetails = ({ trigger }: Props) => {
  const vaultAddress = trigger.context?.vault_address ?? '';

  const venueLabel = useMemo(() => {
    const venue = trigger.context?.venue;
    if (!venue) return '-';
    return EXPONENT_VENUE_LABELS[venue as ExponentVenue] ?? venue;
  }, [trigger.context]);

  const vaultDisplay = useMemo(() => {
    if (!vaultAddress) return '-';
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <AddressChip
          address={vaultAddress}
          scannerUrl={`https://explorer.solana.com/address/${vaultAddress}`}
          hideChainIcon
        />
      </div>
    );
  }, [vaultAddress]);

  const venueDisplay = useMemo(() => {
    if (venueLabel === '-') return '-';
    return <Badge variant="default">{venueLabel}</Badge>;
  }, [venueLabel]);

  const networkDisplay = (
    <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
      <Image src="/assets/webp/solana.webp" alt="Solana" width={20} height={20} />
      <span>Solana</span>
    </div>
  );

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed with" value="Snapshots of Exponent positions for vault">
        <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center tw:flex-wrap tw:ml-2">{vaultDisplay}</div>
      </KeyValueRow>
      <KeyValueRow label="Venue" value={venueDisplay} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
};
